// 活动广场路由
// 首页
const EventPlaza = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/index.vue')),
  'EventPlaza'
)

// 文章
const eventArticleContent = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/article-content/index.vue')),
  'eventArticleContent'
)
// 视频
const eventVideoContent = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/video-content/index.vue')),
  'eventVideoContent'
)
// 广场聚合页
const EventPlazaIndex = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/index/index.vue')),
  'EventPlazaIndex'
)
// 广场首页
const EventPlazaHome = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/home/index')),
  'EventPlazaIndex'
)
// 话题首页
const eventPlazaContestList = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/contest-list/index')),
  'EventPlazaIndex'
)
// 帖子详情
const eventPlazaPostInfo = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/topic/post-info')),
  'EventPlazaPostInfo'
)

// 话题首页
const eventPlazaTopic = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/topic/')),
  'eventPlazaTopic'
)

// 话题首页
const eventPlazaPostPublish = r => require.ensure(
  [],
  () => r(require('@/components/event-plaza/post/publish')),
  'eventPlazaPostPublish'
)

export default [
  // 首页
  {
    path: '/EventPlaza',
    name: 'EventPlaza',
    redirect: '/EventPlaza/index',
    component: EventPlaza,
    children: [
      // 广场聚合页面
      {
        path: 'index',
        name: 'EventPlaza_Index',
        component: EventPlazaIndex
      },
      // 广场首页
      {
        path: 'home',
        name: 'EventPlazaHome',
        component: EventPlazaHome,
        meta: {
          keepAlive: false, // 需要被缓存
          scrollTop: 0
        }
      },
      // 文章内容
      {
        path: 'articleContent',
        name: 'eventArticleContent',
        component: eventArticleContent
      },
      // 视频内容
      {
        path: 'videoContent',
        name: 'eventVideoContent',
        component: eventVideoContent
      },
      // 话题首页
      {
        path: 'ContestList',
        name: 'EventPlazaContestList',
        component: eventPlazaContestList
      },
      // 话题首页
      {
        path: 'TopicPage',
        name: 'EventPlazaTopic',
        component: eventPlazaTopic
      },
      // 帖子详情
      {
        path: 'postInfo',
        name: 'EventPlazaPostInfo',
        component: eventPlazaPostInfo
      },
      // 发帖
      {
        path: 'postPublish',
        name: 'EventPlazaPostPublish',
        component: eventPlazaPostPublish
      }
    ]
  }

]



// WEBPACK FOOTER //
// ./src/router/sub-route/event-plaza.js